"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeRuleSetToBufferV1 = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const generated_1 = require("./generated");
const revisions_1 = require("./revisions");
const writeRuleSetToBufferV1 = (context, input) => {
    const payer = input.payer ?? context.payer;
    const chunkSize = input.chunkSize ?? 900;
    const bufferPda = (0, generated_1.findRuleSetBufferPda)(context, { owner: payer.publicKey });
    const serializedRevision = (0, revisions_1.getRuleSetRevisionSerializer)().serialize(input.ruleSetRevision);
    const bufferSize = serializedRevision.length;
    const numberOfWrites = Math.ceil(bufferSize / chunkSize);
    const writeInstructions = Array.from({ length: numberOfWrites }, (_, index) => {
        const slice = serializedRevision.slice(index * chunkSize, Math.min((index + 1) * chunkSize, serializedRevision.length));
        return (0, generated_1.writeToBufferV1)(context, {
            payer,
            bufferPda,
            data: slice,
            overwrite: index === 0,
        });
    });
    return (0, umi_1.transactionBuilderGroup)((0, umi_1.transactionBuilder)()
        .add(writeInstructions)
        .unsafeSplitByTransactionSize(context)).sequential();
};
exports.writeRuleSetToBufferV1 = writeRuleSetToBufferV1;
//# sourceMappingURL=writeRuleSetToBufferV1.js.map